import React from 'react';
import { Files } from 'services/leads';
import { StatusFiles } from 'const/option';
import { IconButton, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { capitalizeFirstLetter } from 'const/common';
import { TFile } from 'types/user';
import DeleteIcon from '@mui/icons-material/Delete';
type HeaderTableFile = {
  index: number;
  label: string;
  width: number;
  sort?: string;
};

export const getHomeClosedFileStatusLabel = (status: string, previousStatus?: string) => {
  if (status === 'SEIZURE' || status === 'POST_SEIZURE') {
    return 'Close Seized';
  }
  if (status === 'CLOSE_REDEMPTION' && previousStatus === 'POST_SEIZURE') {
    return 'Close Seized';
  }
  return capitalizeFirstLetter(status.replaceAll('_', ' ') || 'Close Seized');
};

export const defaultHeadersClose = [
  { label: 'First Name', width: 120 },
  { label: 'Last Name', width: 140 },
  { label: 'Status', width: 140 },
  { label: 'Year', width: 80 },
  { label: 'Make', width: 80 },
  { label: 'Model', width: 120 },
  { label: 'VIN', width: 120 },
  { label: 'File Number', width: 100 },
  { label: 'Action', width: 80 }
];
export const renderDataCloseFileTable = ({
  rows,
  onDelete
}: {
  rows: { id: number; status: string; file: Files }[];
  onDelete: (value: { id: number; status: string; file: Files }) => void;
}) => {
  return rows.map((item: { id: number; status: string; file: Files; previousStatus?: string }) => {
    return {
      firstName: {
        value: (
          <TextStyled fontSize={'12px'} color={'#000'}>
            {item.file.firstName}
          </TextStyled>
        )
      },
      lastName: {
        value: <TextStyled fontSize={'12px'}>{item.file.lastName}</TextStyled>
      },
      status: {
        value: (
          <Stack
            style={{
              alignItems: 'flex-start',
              justifyContent: 'center',
              height: '100%'
            }}>
            <Stack
              style={{
                background: '#686E7D',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0px 10px',
                height: '20px',
                borderRadius: '5px'
              }}>
              <Typography
                style={{
                  color: '#fff',
                  fontSize: '10px',
                  fontWeight: 600
                }}>
                {getHomeClosedFileStatusLabel(item.status, item.previousStatus)}
              </Typography>
            </Stack>
          </Stack>
        )
      },
      ...(item.file.leadTitle
        ? { leadTitle: { value: <TextStyled>{item.file.leadTitle}</TextStyled> } }
        : {}),
      year: {
        value: <TextStyled>{item.file.year}</TextStyled>
      },
      make: {
        value: <TextStyled>{item.file.make}</TextStyled>
      },
      model: {
        value: <TextStyled>{item.file.model}</TextStyled>
      },
      vin: {
        value: (
          <TextStyled>
            {item.file.vin.length > 8 ? item.file.vin.slice(-8) : item.file.vin}
          </TextStyled>
        )
      },
      fileNumber: {
        value: <TextStyled>{item.file.fileNumber}</TextStyled>
      },
      action: {
        value: (
          <IconButton onClick={() => onDelete(item)}>
            <DeleteIcon />
          </IconButton>
        )
      }
    };
  });
};

export const headerTableFile = (customHeaders?: HeaderTableFile[]) => {
  const defaultHeaders = [
    { label: '', width: 40 },
    { label: 'First Name', width: 120, sort: 'firstName' },
    { label: 'Last Name', width: 140, sort: 'lastName' },
    { label: 'Status', width: 100 },
    { label: 'Year', width: 80, sort: 'year' },
    { label: 'Make', width: 80, sort: 'make' },
    { label: 'Model', width: 120, sort: 'model' },
    { label: 'VIN', width: 100, sort: 'vin' },
    { label: 'Colour', width: 100, sort: 'colour' },
    { label: 'Plate', width: 100, sort: 'plate' },
    { label: 'Note', width: 200 }
  ];

  if (customHeaders?.length) {
    customHeaders.forEach(({ index, ...header }) => {
      const validIndex = index > defaultHeaders.length ? defaultHeaders.length : index - 1;
      defaultHeaders.splice(validIndex, 0, header);
    });
  }

  return defaultHeaders;
};
export const infoStickies = [
  {
    index: 0,
    leftSpace: 0
  },
  {
    index: 1,
    leftSpace: 40,
    isBorder: true
  },
  {
    index: 2,
    leftSpace: 80,
    isBorder: true
  }
];

export const renderDataMapFileTable = (rows: TFile[]) => {
  return rows.map((item: TFile) => {
    const status = item.status;
    const findStatus = StatusFiles?.find((item) => item.value === status);
    return {
      remind: {
        value: !!item.leads?.find((item) => item.flag) && (
          <Stack style={{ width: 20, height: 20, borderRadius: 20, background: 'red' }} />
        )
      },
      firstName: {
        value: (
          <TextStyled fontSize={'12px'} color={'#000'}>
            {item.firstName}
          </TextStyled>
        )
      },
      lastName: {
        value: <TextStyled fontSize={'12px'}>{item.lastName}</TextStyled>
      },
      status: {
        value: (
          <Stack
            style={{
              alignItems: 'flex-start',
              justifyContent: 'center',
              height: '100%'
            }}>
            <Stack
              style={{
                background: findStatus?.color || '#9747FF',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0px 10px',
                height: '20px',
                borderRadius: '5px'
              }}>
              <Typography
                style={{
                  color: '#fff',
                  fontSize: '10px',
                  fontWeight: 600
                }}>
                {[
                  findStatus?.value?.charAt(0)?.toUpperCase() ?? '',
                  findStatus?.value?.slice(1)?.toLocaleLowerCase() ?? ''
                ].join('')}
              </Typography>
            </Stack>
          </Stack>
        )
      },
      year: {
        value: <TextStyled>{item.year}</TextStyled>
      },
      make: {
        value: <TextStyled>{item.make}</TextStyled>
      },
      model: {
        value: <TextStyled>{item.model}</TextStyled>
      },
      vin: {
        value: <TextStyled>{item.vin.length > 8 ? item.vin.slice(-8) : item.vin}</TextStyled>
      },
      colour: {
        value: <TextStyled>{item.colour}</TextStyled>
      },
      plate: {
        value: <TextStyled>{item.plate}</TextStyled>
      },
      note: {
        value: <TextStyled>{item.quickNote}</TextStyled>
      },
      ...(item.phoneNumber
        ? { phoneNumber: { value: <TextStyled>{item.phoneNumber}</TextStyled> } }
        : {}),
      ...(item.address ? { address: { value: <TextStyled>{item.address}</TextStyled> } } : {})
    };
  });
};

const TextStyled = styled(Typography)(() => ({
  fontSize: '12px',
  fontWeight: '400',
  color: '#000'
}));
